import React from "react";
import Recaptcha  from './Recaptcha'
import { connect } from 'react-redux'
import {Field, change} from 'redux-form'
import { showJcaptcha, hideJcaptcha, refreshJcaptcha } from '../actions/unoCaptcha'

class UnoCaptchaImplComponent extends React.Component {
    constructor(props) {
        super(props);
        this.disableCaptcha = this.props.disableCaptcha;
        this.formName = this.props.formName;
        this.siteKey = this.props.siteKey;
        this.jcaptchaImage = this.props.jcaptchaImage;
        this.jcaptchaLabel = this.props.jcaptchaLabel;
        this.jcaptchaRefreshLabel = this.props.jcaptchaRefreshLabel ? this.props.jcaptchaRefreshLabel : 'Refresh';
        this.dispatch = this.props.dispatch;
        this.captchaFieldName = this.props.input.name;
        this.unoCaptchaRef = this.props.unoCaptchaRef;
        this.changeCallback = this.props.changeCallback;
        this.recaptchaHolder = {};
        this.initialRandomizer = (new Date()).getTime();
        this.action = this.props.action;

        this.onloadCallback = this.onloadCallback.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);
        this.expiredCallback = this.expiredCallback.bind(this);
        this.refreshJcaptcha = this.refreshJcaptcha.bind(this);
        this.recaptchaRefGetter = this.recaptchaRefGetter.bind(this);
        this.makeUnoCaptchaInstance = this.makeUnoCaptchaInstance.bind(this);
        this.form = this.props.form;
    }

    componentDidMount() {
        if (this.disableCaptcha) {
            this.dispatch(change(this.formName, this.captchaFieldName, "*"));
        } else {
            this.showJcaptchaTimer = setTimeout(() => {
                const fieldUnoCaptcha = this.props.unoCaptcha && this.props.unoCaptcha[this.captchaFieldName] ?
                    this.props.unoCaptcha[this.captchaFieldName] : {};
                if (fieldUnoCaptcha.showJcaptcha === false){
                    // This means that we already set the values to false in the code (hideJcaptcha is already called).
                    // Don't show it again.
                    return;
                } else {
                    this.dispatch(showJcaptcha(this.captchaFieldName));
                }
            }, 1000);
        }

        if (this.unoCaptchaRef){
            this.unoCaptchaRef(this.makeUnoCaptchaInstance());
        }
    }

    onloadCallback() {
        if (this.showJcaptchaTimer) {
            clearTimeout(this.showJcaptchaTimer);
        }
        // In case if it takes more than 1 second for google to call the callback, we need to make sure the jcaptcha
        // section is hidden.
        this.dispatch(hideJcaptcha(this.captchaFieldName));
    }

    makeUnoCaptchaInstance() {
        const dispatch = this.dispatch;
        const refreshJcaptchaAction = refreshJcaptcha(this.captchaFieldName);
        const recaptchaHolder = this.recaptchaHolder;
        const disableCaptcha = this.disableCaptcha;
        const changeCallback = this.changeCallback;
        const formName = this.formName;
        const captchaFieldName = this.captchaFieldName;
        const daProps = this.props;
        const action = this.action;

        const result =  {
            reset: () => {
                if (disableCaptcha) {
                    return;
                }
                dispatch(refreshJcaptchaAction);
                if (recaptchaHolder.recaptchaRef) {
                    recaptchaHolder.recaptchaRef.reset();
                }
            },
            execute: () => {
                const recaptchaRef =  recaptchaHolder.recaptchaRef;
                if (recaptchaRef && recaptchaRef.isRecaptchaReady()){
                    // Recaptcha is defined, so just call execute so google can do its magic.
                    recaptchaRef.execute(action);
                } else if (changeCallback) {
                    changeCallback();
                }
            }
        };
        return result;
    }

    recaptchaRefGetter(ref) {
        this.recaptchaHolder.recaptchaRef = ref;
    }

    verifyCallback(response) {
        const action = change(this.formName, this.captchaFieldName, response);
        this.dispatch(action);
        const changeCallback = this.changeCallback;
        if (changeCallback) {
            setTimeout(function () {
                changeCallback();
            }, 10);
        }
    }

    expiredCallback() {
        this.dispatch(change(this.formName, this.captchaFieldName, ""));
    }

    refreshJcaptcha() {
        this.dispatch(refreshJcaptcha(this.captchaFieldName));
    }

    render() {
        const textInputProps = {
            ...this.props.input,
            className: "text-input",
            type: "text"
        };

        const randomizer = this.props.unoCaptcha && this.props.unoCaptcha[this.captchaFieldName] && this.props.unoCaptcha[this.captchaFieldName].jcaptchaImageRandomizer ?
            this.props.unoCaptcha[this.captchaFieldName].jcaptchaImageRandomizer : this.initialRandomizer;

        if (this.disableCaptcha){
            return (<div />);
        }

        const meta = this.props.meta;
        return (
            <div>
                {
                    this.props.unoCaptcha && this.props.unoCaptcha[this.captchaFieldName] && this.props.unoCaptcha[this.captchaFieldName].showJcaptcha &&
                    (
                        <div className="required">
                            <label forName={this.captchaFieldName}>{this.jcaptchaLabel}</label>
                            <input {...textInputProps} />
                            <div className="push-half--top">
                                <img id="imgCaptcha" src={this.jcaptchaImage + "?rand=" + randomizer}/>
                                <i title={this.jcaptchaRefreshLabel}
                                   className="fa fa-refresh clickable unocaptcha--jcaptcha--refresh"
                                   onClick={this.refreshJcaptcha}></i>
                            </div>
                            {meta && meta.touched && !meta.valid && meta.error && <div id={this.captchaFieldName + "Error"} className="red">{meta.error}</div>}
                        </div>
                    )
                }
                <Recaptcha
                    sitekey={this.siteKey}
                    onloadCallback={this.onloadCallback}
                    verifyCallback={this.verifyCallback}
                    expiredCallback={this.expiredCallback}
                    ref={this.recaptchaRefGetter}
                    elementID={this.captchaFieldName + "Recaptcha"}
                />
            </div>

        );

    }
}

const mapStateToProps = (state, ownProps) => ({
    ...ownProps,
    unoCaptcha: state.unoCaptcha,
    form: state.form,
    state: state
});

const UnoCaptchaComponent = connect(mapStateToProps)(UnoCaptchaImplComponent);
export default UnoCaptchaComponent;


